import { JSX } from "react";
import { AuthorizationStatus } from "../../utils/enums/AuthorizationStatus";
import { Navigate } from "react-router-dom";
import { AppRouter } from "../../utils/enums/AppRouter";

interface LoginPageAuthorizationRouteProps {
  authorisationStatus: AuthorizationStatus;
  children: JSX.Element;
}

export const LoginPageAuthorizationRoute = ({
  authorisationStatus: authorizationStatus,
  children,
}: LoginPageAuthorizationRouteProps) => {
  return authorizationStatus !== AuthorizationStatus.Auth ? (
    children
  ) : (
    <Navigate to={AppRouter.Main} />
  );
};
